/* tslint:disable */

declare var Object: any;
export interface TrainingPlanAchievementInterface {
  "sfdcId"?: string;
  "IsDeleted"?: boolean;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedDate"?: Date;
  "CreatedById"?: string;
  "LastModifiedDate"?: Date;
  "LastModifiedById"?: string;
  "LastActivityDate"?: Date;
  "Type__c"?: string;
  "Main_Achievement__c"?: boolean;
  "Achievement__c"?: string;
  "Training_Plan__c"?: string;
  "Training_Plan_Section__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class TrainingPlanAchievement implements TrainingPlanAchievementInterface {
  "sfdcId": string;
  "IsDeleted": boolean;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedDate": Date;
  "CreatedById": string;
  "LastModifiedDate": Date;
  "LastModifiedById": string;
  "LastActivityDate": Date;
  "Type__c": string;
  "Main_Achievement__c": boolean;
  "Achievement__c": string;
  "Training_Plan__c": string;
  "Training_Plan_Section__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: TrainingPlanAchievementInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TrainingPlanAchievement`.
   */
  public static getModelName() {
    return "TrainingPlanAchievement";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TrainingPlanAchievement for dynamic purposes.
  **/
  public static factory(data: TrainingPlanAchievementInterface): TrainingPlanAchievement{
    return new TrainingPlanAchievement(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TrainingPlanAchievement',
      plural: 'TrainingPlanAchievements',
      path: 'TrainingPlanAchievements',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "Type__c": {
          name: 'Type__c',
          type: 'string'
        },
        "Main_Achievement__c": {
          name: 'Main_Achievement__c',
          type: 'boolean'
        },
        "Achievement__c": {
          name: 'Achievement__c',
          type: 'string'
        },
        "Training_Plan__c": {
          name: 'Training_Plan__c',
          type: 'string'
        },
        "Training_Plan_Section__c": {
          name: 'Training_Plan_Section__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
